import { LimitRedistributionLimitDetail } from "@ploy-lib/rest-resources";
import {
	FieldType,
	IFormTableSchema,
	ColumnMetadata,
	TableMetadata
} from "./types";

export class LimitRedistributionSchema
	implements IFormTableSchema<LimitRedistributionLimitDetail>
{
	tableMetadata: TableMetadata<Partial<LimitRedistributionLimitDetail>> = {};

	columnMetadata: Partial<
		Record<
			keyof LimitRedistributionLimitDetail,
			ColumnMetadata<LimitRedistributionLimitDetail>
		>
	> = {
		applicationNumber: {
			fieldType: FieldType.Text
		},
		limitGuid: {
			fieldType: FieldType.Select
		}
	};
}
